// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelsPage-ListWrapper_cls1__Aq7AW","cls2":"PaymentChannelsPage-ListWrapper_cls2__QgO55 PaymentChannelsPage-ListWrapper_cls1__Aq7AW"};